// import HomePage from 'pages/HomePage';
import {SlideStatsMobile} from './components/SlideStatsMobile';

$(document).ready(() => {
    // const homePage = new HomePage();

    let slideStatsMobile = new SlideStatsMobile();
    slideStatsMobile.init();

    function halfSlider() {
        if ($('[data-js="half-slider"]').length){
            $('[data-js="half-slider"]').slick({
                dots: true,
                infinite: true,
                speed: 550,
                fade: true,
                autoplay: true,
                autoplaySpeed: 5500,
                cssEase: 'linear',
                prevArrow: '<div class="slick-prev"><svg class="icon icon-arow_one"><use xlink:href="static/ui/symbol-defs.svg#icon-arow_one"></use></svg></div>',
                nextArrow: arrow_one,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {}
                    },
                    {
                        breakpoint: 600,
                        settings: {}
                    },
                    {
                        breakpoint: 480,
                        settings: {}
                    }
                ]
            });
        }
    }



    function coverVideo(isVisible) {
        var isPlayed = false;

        if ($('.js-cover-video').length) {
            $(window).scroll(function () {
                if (isPlayed === false && !$(isVisible).isOnScreen(0.03, 0.03)) {
                    $.js('video')[0].play();
                    isPlayed = true;
                }
            });
        }
    }

    halfSlider();
    coverVideo();


    function inform() {
        if ($('[data-js="inform"]').length) {
            var inform = $('[data-js="inform"]'),
                height = $(inform).outerHeight(),
                close = $('[data-js="close-inform"]');

            $(inform).addClass('is-active');
            $('[data-js="header"], [data-js="main-wrapper"]').css({
                '-webkit-transform': 'translateY(' + height + 'px)'
                , '-moz-transform': 'translateY(' + height + 'px)'
                , 'transform': 'translateY(' + height + 'px)'
            });

            $(close).on("click", function (e) {
                e.preventDefault();
                closeInform();
            });
        }

    }

    function closeInform() {
        if ($('[data-js="inform"]').length) {
            $('[data-js="inform"]').removeClass('is-active');
            // $('[data-js="header"], [data-js="main-wrapper"]').css({
            //     '-webkit-transform': 'translateY(' + 0 + 'px)'
            //  , '-moz-transform': 'translateY(' + 0 + 'px)'
            //  , 'transform': 'translateY(' + 0 + 'px)'
            // });
            $('[data-js="header"], [data-js="main-wrapper"]').removeAttr('style');
        }
    }

    function initInform() {
        $(window).on('load', function () {
            inform();
        });
        $(window).on('resize', function () {
            closeInform();
        });
    }

    initInform();

});


// WEBPACK FOOTER //
// ./static/js/index.js